// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionOutlinedSvg from "@fishx/icons-svg/es/asn/QuestionOutlined";
import FishxIcon from '../components/FishxIcon';

var QuestionOutlined = function QuestionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionOutlinedSvg
  }));
};

QuestionOutlined.displayName = 'QuestionOutlined';
export default React.forwardRef(QuestionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QuestionOutlined.js
// module id = 3958
// module chunks = 0